import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../services/services.index';
import { UserToken } from '../interfaces/interfaces.index';
import { substracTime } from '../shared/config/commons';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  count = 0;
  constructor(
    private authService: UserService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authService.currentUserValue;
    const userToken = (this.authService.userToken || JSON.parse(sessionStorage.getItem('userToken')));
    if (currentUser && userToken) {
      const dateExp = substracTime(new Date(userToken?.expiration), 10).getTime() - new Date().getTime();
      if (dateExp > 0) { this.count = 0; }
      if (this.count === 0 && dateExp < 0) {
        this.count++;
        this.refresh();
      }

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${(JSON.parse(sessionStorage.getItem('userToken')) as UserToken).token}`
        }
      });
    }
    if(this.authService.keyChangePass) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.keyChangePass}`
        }
      });
    }
    return next.handle(request);
  }

  refresh = () => this.authService.refreshToken().subscribe(res => {
    this.authService.userToken = res;
    sessionStorage.setItem('userToken', JSON.stringify(res));
  })

}
